import QuestionLabel from './QuestionLabel';
import SafeHtml from '../../SafeHtml.jsx';
import { FormPart, part } from '~/lib/FormCssApi';
import useCurrentBusiness from '~/lib/useCurrentBusiness.jsx';

const DisplayTextQuestion = ({ label, value, setValue, settings }) => {
    const business = useCurrentBusiness();
    const isSpam = !!business?.is_spam;

    return (
        <label>
            <QuestionLabel label={label} settings={settings} />

            <div
                {...part(FormPart.DESCRIPTION)}
                className="display-text-question"
            >
                <SafeHtml html={settings?.display} stripLinks={isSpam} />
            </div>
        </label>
    );
};

export default DisplayTextQuestion;
